import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from "../../shared/shared.module";
import { AccountDetailComponent } from './account-detail/account-detail.component';
import { AccountPositionsComponent } from './account-positions/account-positions.component';
import { AllAccountsComponent } from './all-accounts/all-accounts.component';
import { LongShortPipe } from 'src/app/shared/longshort.pipe';
@NgModule({
    declarations: [
        AccountDetailComponent,
        AccountPositionsComponent,
        AllAccountsComponent,
    ],
    imports: [
        SharedModule,
        LongShortPipe,  // Include LongShortPipe here in declarations
        RouterModule  // Import RouterModule here if routing is needed in this module
    ]
})
export class AccountModule { }
